import React from 'react';

export const ExternalLayout = ({ children }) => <>{children}</>;
